import React, { useEffect, useState } from "react";
import { Provider } from "../../components/alert/AlertController.jsx";
import Template from "./Shop.jsx";
import { get } from "../../util/fetch.js";
import { useFavourite } from "../cart/hooks/useFavourite.jsx";
import { removeDiacritics } from "../../util/script.js";

function Shop(props) {
  const [showRegistrationForm, setShowRegistrationForm] = useState(false);
  const [activeSearch, setActiveSearch] = useState(false);
  const [hasBeenClicked, setHasBeenClicked] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [productType, setProductType] = useState([]);
  const [filteredProductType, setFilteredProductType] = useState([]);
  const [categories, setCategories] = useState([]);
  const [catalog, setCatalog] = useState([]);
  const [catalogLoaded, setCatalogLoaded] = useState(false);
  const [reRender, setRender] = useState(false);
  const [fromFooter, setFromFooter] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredCatalog, setFilteredCatalog] = useState();
  const {
    colorSecondary,
    logoSmallUrl,
    companyAddress,
    bioCertification,
    taxDetails,
    privacyPage,
  } = props;

  const cleanText = (str) => removeDiacritics(str || "").toLowerCase();

  const search = (text) => {
    setSearchText(text);
    const cleanedText = cleanText(text);
    if (cleanedText.length > 0 && catalog) {
      setActiveSearch(true);
      const tempFilteredCatelog = catalog.filter((item) => {
        const matchArticleNameAndQualities = cleanText(
          item.article_name_and_qualities,
        ).includes(cleanedText);
        const matchCategories = item.categories.some((sub_category) => {
          return cleanText(sub_category.category).includes(cleanedText) || 
                 cleanText(sub_category.subcategory).includes(cleanedText);
        });
        const matchProducer = item.article.producer
          ? cleanText(item.article.producer).includes(cleanedText)
          : false;
        return matchArticleNameAndQualities || matchCategories || matchProducer;
      });
      setFilteredCatalog(tempFilteredCatelog);
      return tempFilteredCatelog;
    } else {
      setActiveSearch(false);
      setFilteredCatalog([...catalog]);
      return [...catalog];
    }
  };

  const {
    isCatalogEmpty,
    productsByCategory,
    filteredProductsByCategory,
    onFavouriteAddRemove,
  } = useFavourite(
    categories,
    catalog,
    searchText,
    filteredCatalog,
    catalog,
    undefined,
    search,
  );
  const fetchCatalog = async () => {
    const url = `${location.origin}/api/shop-catalog`;
    await get(url)
      .then((resp) => {
        setCategories([...resp.all_categories]);
        setCatalog([...resp.catalog]);
        setCatalogLoaded(true);
      })
      .catch((error) => {
        console.log("error: ", error);
      });
  };

  useEffect(() => {
    if (!catalogLoaded) {
      fetchCatalog().catch((error) => {
        console.log("error", error);
      });
    }

    setRender(!reRender);
  }, [catalogLoaded]);

  function onSettingsClose() {
    setShowSettings(false);
  }

  function onTopClick() {
    setShowSettings(true);
  }

  function onSubmit() {}

  return (
    <Template
      activeSearch={activeSearch}
      setActiveSearch={setActiveSearch}
      catalog={catalog}
      catalogLoaded={catalogLoaded}
      shouldRegister={props.shouldRegister}
      isStaff={props.isStaff}
      browser_is_IE={props.browser_is_IE}
      showRegistrationForm={showRegistrationForm}
      setShowRegistrationForm={setShowRegistrationForm}
      hasBeenClicked={hasBeenClicked}
      showSettings={showSettings}
      fromFooter={fromFooter}
      onSubmit={onSubmit}
      onTopClick={onTopClick}
      onSettingsClose={onSettingsClose}
      colorSecondary={colorSecondary}
      logoSmallUrl={logoSmallUrl}
      taxDetails={taxDetails}
      bioCertification={bioCertification}
      companyAddress={companyAddress}
      privacyPage={privacyPage}
      gmbhName={props.gmbhName}
      logoBigUrl={props.logoBigUrl}
      logoFavIcon={props.logoFavIcon}
      phoneNumber={props.phoneNumber}
      companyEmail={props.companyEmail}
      addInvoicePaymentMethod={props.addInvoicePaymentMethod}
      footerTextInShop={props.footerTextInShop}
      defaultCommercialCustomers={props.defaultCommercialCustomers}
      webhost={props.webhost}
      colorPrimary={props.colorPrimary}
      homePage={props.homePage}
      conditionsPage={props.conditionsPage}
      companyName={props.companyName}
      reRender={reRender}
      setRender={setRender}
      search={search}
      productType={productType}
      filteredProductType={filteredProductType}
      setProductType={setProductType}
      setFilteredProductType={setFilteredProductType}
      updated_orders={props.updated_orders}
      was_updated={props.was_updated}
      fetchCatalog={fetchCatalog}
      searchText={searchText}
      setSearchText={setSearchText}
      filteredCatalog={filteredCatalog}
      setFilteredCatalog={setFilteredCatalog}
      isCatalogEmpty={isCatalogEmpty}
      productsByCategory={productsByCategory}
      filteredProductsByCategory={filteredProductsByCategory}
      onFavouriteAddRemove={onFavouriteAddRemove}
      categories={categories}
    />
  );
}

export default Provider(Shop);
